import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { push } from "store/actions/router";
import { Card } from "react-bootstrap";

import Button from "components/Button";

const mapDispatchToProps = {
  push,
};

const connector = connect(null, mapDispatchToProps);

type Props = ConnectedProps<typeof connector>;

const PageNotFound = ({ push }: Props) => {
  return (
    <Card>
      <Card.Body>
        <Card.Title>Page not found</Card.Title>
        <p>
          Uh oh, We can{"'t"} find the page you are looking for. Try going back
          to the previous page or returning to the home page.
        </p>
        <Button
          name="action"
          onClick={() => push("/")}
          btnLabel="Back to Home"
        />
      </Card.Body>
      <div className="page-not-found-container"></div>
    </Card>
  );
};

export default connector(PageNotFound);
